import React from 'react'

export const Metric = ({ value, type, className }) => {
    return (
        <div className={'d-flex flex-column align-items-center ' + className}>
            <span style={{ fontSize: '2em' }} className="mb-2">
                {value}
            </span>
            <span>{type}</span>
        </div>
    )
}
